import r, { css as t } from "styled-components";
import { Button as e } from "./atoms-v26.js";
import { Column as g } from "./atoms-v212.js";
import { Grid as m } from "./atoms-v216.js";
import { Base as x, UL as $, LI as f, Button as S } from "./atoms-v2777.js";
import { breakpoints as a } from "./atoms-v2125.js";
import { SlideSize as d } from "./atoms-v21044.js";
import { Picture as p } from "./atoms-v233.js";
const v = {
  small: {
    [d.Small]: 0.37892377,
    [d.Medium]: 0.48360656
  },
  medium: {
    [d.Small]: 0.37892377,
    [d.Medium]: 0.48360656
  },
  large: {
    [d.Small]: 0.348,
    [d.Medium]: 0.435
  },
  xLarge: {
    [d.Small]: 0.29,
    [d.Medium]: 0.3658
  },
  max: {
    [d.Small]: 0.24667438,
    [d.Medium]: 0.3
  }
}, V = r(m)`
  ${x}

  position: relative;
  width: 100%;

  ${({ $variant: i }) => {
  if (i === "v3")
    return t`
        border-radius: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.radius.layerBorder")}px;
        overflow: hidden;
      `;
}};
`, l = r.ul`
  ${$}
`, s = r.li`
  ${f}

  list-style: none;
  position: relative;
  will-change: transform, opacity;

  picture,
  img {
    flex: 1;
    pointer-events: none;
  }

  picture {
    position: relative;
    z-index: 1;
  }
`, b = r.button`
  ${S}

  border-radius: ${({ theme: i }) => i == null ? void 0 : i.get("tokens.radius.layerBorder")}px;
  cursor: inherit;
  inset: 0;
  position: absolute;
  z-index: 2;
`, H = r(e)`
  bottom: 16px;
  padding: 4px 12px;
  position: absolute;
  right: 16px;
`, w = r.div`
  display: flex;
  gap: 8px;
  height: 100%;

  > div {
    display: flex;
    flex: 1;
    overflow: hidden;
  }
`, W = r(l)`
  display: grid;
  grid-gap: 8px;
  grid-template-rows: repeat(2, min-content);

  ${s} {
    display: flex;
    overflow: hidden;
  }

  ${s}:nth-child(1) {
    grid-row: 1 / span 2;

    @media ${a.large} {
      grid-column: 1 / span 4;

      > picture {
        > img {
          border-radius: ${({ theme: i }) => i == null ? void 0 : i.get("tokens.radius.cardRadiusSm")}px 0 0
            ${({ theme: i }) => i == null ? void 0 : i.get("tokens.radius.cardRadiusSm")}px;
        }
      }
    }

    @media ${a.xLarge} {
      grid-column: 1 / span 8;
    }

    @media ${a.max} {
      grid-column: 2 / span 7;
    }
  }

  ${s}:nth-child(2) {
    grid-row: 1 / span 1;

    @media ${a.large} {
      grid-column: 5 / span 4;

      > picture {
        > img {
          border-radius: 0 ${({ theme: i }) => i == null ? void 0 : i.get("tokens.radius.cardRadiusSm")}px 0 0;
        }
      }
    }

    @media ${a.xLarge} {
      grid-column: 9 / span 8;
    }

    @media ${a.max} {
      grid-column: 9 / span 7;
    }
  }

  ${w} {
    grid-row: 2 / span 1;

    @media ${a.large} {
      grid-column: 5 / span 4;

      > div:nth-child(1) {
        > ${s} {
          > picture {
            > img {
              border-radius: 0;
            }
          }
        }
      }

      > div:nth-child(2) {
        > ${s} {
          > picture {
            > img {
              border-radius: 0 0 ${({ theme: i }) => i == null ? void 0 : i.get("tokens.radius.cardRadiusSm")}px 0;
            }
          }
        }
      }
    }

    @media ${a.xLarge} {
      grid-column: 9 / span 8;
    }

    @media ${a.max} {
      grid-column: 9 / span 7;
    }
  }

  @media ${a.large} {
    grid-template-columns: repeat(8, 1fr);
  }

  @media ${a.xLarge} {
    grid-template-columns: repeat(16, 1fr);
  }
`, D = r(l)`
  aspect-ratio: ${({ $aspectRatio: i }) => i};
  overflow: hidden;

  ${({ theme: i }) => {
  const o = i == null ? void 0 : i.get("tokens.breakpoints.small.margin"), n = i == null ? void 0 : i.get("tokens.breakpoints.medium.margin");
  return t`
      margin-left: calc(-1 * ${o}px);
      margin-right: calc(-1 * ${o}px);
      width: calc(100% + 2 * ${o}px);

      @media ${a.medium} {
        margin-left: calc(-1 * ${n}px);
        margin-right: calc(-1 * ${n}px);
        width: calc(100% + 2 * ${n}px);
      }
    `;
}}
`, G = r(g)`
  overflow-x: hidden;
`, j = r(s)`
  display: flex;
  flex-basis: var(--width);
  flex-direction: column;
  flex-shrink: 0;
  padding-right: 8px;
  row-gap: 8px;

  ${b} {
    border-radius: 0;
  }

  ${({ $size: i, theme: o }) => Object.keys(a).map((n) => {
  const c = v[n], u = o == null ? void 0 : o.get(`tokens.breakpoints.${n}.margin`);
  return t`
        @media ${a[n]} {
          --width: ${`calc((100% - ${u}px) * ${c[i]})`};
        }
      `;
})}
`, N = r(l)`
  align-items: start;
  column-gap: 8px;
  display: flex;
`, O = r.div`
  ${({ theme: i }) => {
  var o;
  return (o = i == null ? void 0 : i.get("tokens.body.compact-expressive")) == null ? void 0 : o.toJS();
}}
`, A = r.div`
  display: flex;
  flex-direction: column;
  row-gap: 2px;
`, T = r(e)`
  opacity: ${({ $hidden: i }) => i ? 0 : 1};
  position: absolute;
  top: 50%;
  transform: translateY(-50%);

  ${({ $direction: i }) => i === "next" ? t`
          right: 24px;
        ` : t`
          left: 24px;
        `};
`, _ = r.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 16px;
  width: 100%;
`, C = r.div`
  display: flex;
  justify-content: center;
  width: 100%;
`, E = r(p)`
  > img {
    border-radius: ${({ theme: i }) => i == null ? void 0 : i.get("tokens.radius.cardRadiusMed")}px;
  }
`, F = r(p)`
  @media ${a.large} {
    > img {
      border-radius: ${({ theme: i }) => i == null ? void 0 : i.get("tokens.radius.cardRadiusSm")}px;
    }
  }
`, J = r.div`
  position: relative;
`;
export {
  V as Gallery,
  G as HorizontalWrapper,
  T as NavigationButton,
  J as RelativeWrapper,
  E as RoundedImageV2,
  F as RoundedImageV3,
  s as Slide,
  b as SlideButton,
  A as SlideDetails,
  _ as SlideDetailsWrapper,
  j as SlideHorizontal,
  O as SlideNumber,
  l as Slides,
  D as SlidesFullscreen,
  N as SlidesHorizontal,
  w as Variant1SlideGroup,
  W as Variant1SlidesGrid,
  C as Variant3Wrapper,
  H as ViewAllButton
};
